import { html, TemplateResult } from "lit/html.js";
import { map } from "lit/directives/map.js";
import { range } from 'lit/directives/range.js';
import { ButtonComponent, InputComponent, LabelComponent } from "@components/common";
import '@components/typeahead/location';

const MySearchesTemplate = (
  config: ProposalConfigs,
  model: IProposalModel): TemplateResult => {
  const {
    messages: {
      SearchWhat,
      SearchWhere,
      RegistrationWhat,
      MySearchesDIVButtonNo,
      MySearchesDIVButtonAdd,
      ProposalPopupLocationLabel
    }
  } = config;

  const {
    formData,
    handleOneSearchSubmit,
    handleMySearchesSubmit,
    handleWhere1Input,
    handleWhere2Input
  } = model;

  return html`
    <div class="modal-body my-searches">
      <form
        class="my-searches-form"
        name="forms.my-searches"
        @submit=${handleMySearchesSubmit}
        novalidate
      >
      ${map(range(3), (index) => html`
        <div class="my-searches-container__row">
          <div class="my-searches-container__input-wrapper">
          ${InputComponent({
    type: 'text',
    name: `what${index}`,
    value: index === 0 ? formData.what.value : '',
    placeholder: SearchWhat,
    cssClasses: `jr-input jr-input-material ${index === 0 ? 'jr-input-material--disabled' : ''} js-mysearch-what${index}`,
    options: {
      disabled: index === 0 || undefined,
    }
  })}
          ${LabelComponent({ cssClasses: 'proposal-form__label', labelText: RegistrationWhat })}
          </div>
          <div class="my-searches-container__input-wrapper">
            <location-typeahead-component
              isLocationLabelEnabled=${false}
              clearButtonEnabled=${false}
              currentValue=${index === 0 ? formData.where.value : ''} 
              labelText=${ProposalPopupLocationLabel}
              placeholder=${SearchWhere}
              fieldName="where${index}"
              disabled=${index === 0 || undefined}
              @location-change-event=${index === 1 && handleWhere1Input || index === 2 && handleWhere2Input}
              >
            </location-typeahead-component>
          </div>
        </div>
      `)}
        <div class="my-searches-form__button-container">
          <a class="jr-button jr-button-material jr-button-material--textual" @click=${handleOneSearchSubmit}>${MySearchesDIVButtonNo}</a>
          ${ButtonComponent({ type: 'submit', cssClasses: 'jr-button jr-button-material', btnText: MySearchesDIVButtonAdd })}
        </div>
      </form>
    </div>`;
}

export default MySearchesTemplate;